<template>
  <v-app
    id="inspire"
    v-if="!userIsLoading && !structureIsLoading && !drIsLoading && user"
  >
    <v-navigation-drawer
      color="blue-grey"
      permanent
      expand-on-hover
      app
      class="elevation-2"
    >
      <v-sheet class="pt-3 pl-1 pr-1 blue-grey text-center">
        <v-img contain height="20px" src="static/img/logo.png" />
        <span class="white--text">GEDI</span>
      </v-sheet>
      <v-list nav dense>
        <v-list-item v-if="user.is_active">
          <v-list-item-title class="white--text">
            {{ user.first_name }} {{ user.last_name }}
          </v-list-item-title>
          <v-list-item-action class="white--text">
            <v-btn link icon href="/api-auth/logout/?next=/">
              <v-icon class="white--text">mdi-export</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <my-items-menu
          v-else
          :link="'/api-auth/login/?next=' + next"
          icon="mdi-account"
          label="Connectez-vous"
          :href="true"
        />
        <my-items-menu link="/" icon="mdi-home" label="Accueil" />
        <v-divider class="mb-2" />

        <template v-if="user && user.is_active">
          <my-items-menu
            link="/contrat"
            icon="mdi-handshake"
            label="Contrats"
          />
          <my-items-menu link="/marche" icon="mdi-shopping" label="Marchés" />
          <my-items-menu link="/tier" icon="mdi-factory" label="Tiers" />
          <my-items-menu link="/commande" icon="mdi-basket" label="Commandes" />
          <my-items-menu
            link="/mission"
            icon="mdi-train-car"
            label="Missions"
          />
          <my-items-menu
            link="/facture"
            icon="mdi-file-document"
            label="Factures"
          />
          <my-items-menu
            link="/bordereau"
            icon="mdi-buffer"
            label="Bordereaux"
          />
          <my-items-menu
            link="/od"
            icon="mdi-blur"
            label="Opérations diverses"
          />
          <my-items-menu
            link="/autredocumentcomptable"
            icon="mdi-piggy-bank"
            label="Autres documents comptables"
          />
          <v-divider class="mt-2 mb-2" />
          <my-items-menu
            v-if="user.is_staff"
            link="/admin/"
            :href="true"
            icon="mdi-cog"
            label="Administration"
          />
          <my-items-menu
            v-if="user.is_create"
            link="/user"
            icon="mdi-account-multiple-plus"
            label="Utilisateurs"
          />
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
    <my-dialog-outils />
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MyDialogOutils from "./components/ged/elems/MyDialogOutils";
import MyItemsMenu from "./components/ged/elems/MyItemsMenu";

export default {
  name: "App",
  components: {
    MyDialogOutils,
    MyItemsMenu,
  },
  data: () => ({
    drawer: null,
    next: "/",
  }),

  computed: {
    ...mapGetters({
      userIsLoading: "user/current/isLoading",
      drIsLoading: "dr/list/isLoading",
      structureIsLoading: "structure/list/isLoading",
      user: "user/current/retrieved",
      title: "general/updated/title",
    }),
  },
  methods: {
    ...mapActions({
      userRetrieve: "user/current/retrieve",
      getDrs: "dr/list/getItems",
      getAllDrs: "dr/list/getAllItems",
      getStructures: "structure/list/getItems",
    }),
  },

  mounted() {
    this.next = window.location.pathname + window.location.search;
    this.userRetrieve();
    this.getDrs();
    this.getAllDrs();
    this.getStructures();
  },
};
</script>

<style scoped></style>
